import { FC, use, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../hooks/ReduxHooks";
import { Navigate, Outlet } from "react-router-dom";
import { me } from "../redux/requests/OperatorRequests";
import Loader from "../components/UI/loader/Loader";

interface IProtectedRoutesProps {}

const ProtectedRoutes: FC<IProtectedRoutesProps> = () => {
  const { operator, isAuthChecked, authLoading } = useAppSelector(
    (state) => state.operator
  );
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!operator && !isAuthChecked) {
      dispatch(me());
    }
  }, [dispatch, operator, isAuthChecked]);

  if (authLoading || !isAuthChecked) {
    return <Loader/>;
  }
  return operator ? <Outlet /> : <Navigate to="/" />;
};

export default ProtectedRoutes;
